import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import MenuSectionHeading from 'components/menu-section-heading';

const Header = styled(MenuSectionHeading)`
  margin: 1.75rem 0;
  font-size: 1.75rem;
  text-align: center;
`;

export const ListViewHeading: React.FC = () => {
  const { formatMessage } = useIntl();

  return <Header>{formatMessage({ id: 'locations' })}</Header>;
};
